import { render, staticRenderFns } from "./EditCongressList.vue?vue&type=template&id=2d7428b0"
import script from "./EditCongressList.vue?vue&type=script&lang=js"
export * from "./EditCongressList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports